import { searchProduct } from "./Action";
import {
  FIND_PRODUCTS_BY_CATEGORY_REQUEST,
  FIND_PRODUCTS_BY_CATEGORY_SUCCESS,
  FIND_PRODUCTS_BY_CATEGORY_FAILURE,
  FIND_PRODUCT_BY_ID_REQUEST,
  FIND_PRODUCT_BY_ID_SUCCESS,
  FIND_PRODUCT_BY_ID_FAILURE,
  CREATE_PRODUCT_REQUEST,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAILURE,
  UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAILURE,
  DELETE_PRODUCT_REQUEST,
  DELETE_PRODUCT_FAILURE,
  DELETE_PRODUCT_SUCCESS,
  SEARCH_PRODUCT_SUCCESS,
  CLEAR_SEARCH_RESULTS,
  FIND_SIMILAR_PRODUCTS_REQUEST,
  FIND_SIMILAR_PRODUCTS_SUCCESS,
  FIND_SIMILAR_PRODUCTS_FAILURE,
  TOGGLE_PRODUCT_ACTIVE_REQUEST,
  TOGGLE_PRODUCT_ACTIVE_SUCCESS,
  TOGGLE_PRODUCT_ACTIVE_FAILURE,
} from "./ActionType";

const initialState = {
  products: [],
  product: null,
  loading: false,
  error: null,
  deleteProduct: null,
  toggleProduct: null,
  searchProducts: [],
  similarProducts: [],
  similarProductsLoading: false,
};

const customerProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case FIND_PRODUCTS_BY_CATEGORY_REQUEST:
      return { ...state, loading: true, error: null, products: [] };
    case FIND_PRODUCTS_BY_CATEGORY_SUCCESS:
      return { ...state, products: action.payload, loading: false };
    case FIND_PRODUCTS_BY_CATEGORY_FAILURE:
      return { ...state, loading: false, products: [], error: action.payload };
    case FIND_PRODUCT_BY_ID_REQUEST:
      return { ...state, loading: true, error: null };
    case FIND_PRODUCT_BY_ID_SUCCESS:
      return { ...state, product: action.payload, loading: false };
    case FIND_PRODUCT_BY_ID_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case CREATE_PRODUCT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        products: [...state.products, action.payload],
      };
    case SEARCH_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        searchProducts: action.payload,
      };
    case CLEAR_SEARCH_RESULTS:
      return {
        ...state,
        searchProducts: [],
        loading: false,
      };

    case CREATE_PRODUCT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_PRODUCT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_PRODUCT_SUCCESS:

      return {
        ...state,
        loading: false,
        products: state.products.map((product) =>
          product.id === action.payload.id ? action.payload : product
        ),
      };
    case UPDATE_PRODUCT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_PRODUCT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_PRODUCT_SUCCESS:
      console.log("dlete ", state.products)
      return {
        ...state,
        loading: false,
        deleteProduct: action.payload


      };
    case DELETE_PRODUCT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    // Similar Products for PDP section
    case FIND_SIMILAR_PRODUCTS_REQUEST:
      return {
        ...state,
        similarProductsLoading: true,
        error: null,
      };
    case FIND_SIMILAR_PRODUCTS_SUCCESS:
      return {
        ...state,
        similarProductsLoading: false,
        similarProducts: action.payload,
      };
    case FIND_SIMILAR_PRODUCTS_FAILURE:
      return {
        ...state,
        similarProductsLoading: false,
        similarProducts: [],
        error: action.payload,
      };
    case TOGGLE_PRODUCT_ACTIVE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case TOGGLE_PRODUCT_ACTIVE_SUCCESS:
      return {
        ...state,
        loading: false,
        toggleProduct: action.payload,
      };
    case TOGGLE_PRODUCT_ACTIVE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default customerProductReducer;
